export default {
    path: '/distributor/information',
    name: 'distributor-information',
    component: () => import('./index.vue'),
    meta: {
        skip_check_token: true,
    },
};
